window.address = {};
window.$panels = null;
window.$shipRates;
window.shipRateXHR;
window.taxRateXHR;
window.orderTotals = {total: 0.00, subtotal: 0.00, tax: 0.00, fees: 0.00, shipping: 0.00, discount: 0.00};

$(window).on('js-onload', function() {

    if($('#checkout-form').length === 0) return;

    window.$panels = $('.checkout-panel');

    window.$shipRates = $('#shipping-rates');

    $(window)
        // recalc totals
        .on('recalc', updateOrderTotal)
        // persist address
        .on('persistAddress', function(event, address, type) {
            type = type || 'ship'; // bill
            $('#show-'+type+'-address').html( Handlebars.templates['address'](address) );

            window.address[type] = address;

            if(type === 'ship' && address.hasOwnProperty('entity_usage_code')) {
              $('[data-has-exemption]').toggleClass('hidden', address.entity_usage_code.toLowerCase().trim() === 'default');
            }
        })
        // update tax
        .on('tax', function(event, address) {
            if(window.taxRateXHR) {
                window.taxRateXHR.abort();
                window.taxRateXHR = null;
            }

            updateTax(address);
        })
        // recalc for shipping method
        .on('change.shipmethod', function(event, $selected, changeEvent) {
            if($selected === undefined || event.namespace !== 'shipmethod') return;

            var cookie = document.cookie.split('; ').find(function(row) {
              return row.indexOf('airShipmentCheck=true') > -1;
            });

            if(!cookie && ['FEDX2D', 'FEDXSO', 'FEDXPO', 'UPS2DA', 'UPSNDA', 'UPSWEX'].indexOf($selected.val()) > -1) {
              $('#airShipmentModal').on('show.bs.modal', function(e) {
                document.cookie = 'airShipmentCheck=true;path=/;max-age=' + (60 * 60 * 2) + ';SameSite=Lax;Secure';
              });

              $('#airShipmentModal').modal({
                backdrop: 'static',
                focus: true,
                keyboard: false,
              });
            }

            var price = $selected.data('price');

            $('#order-freight').text('$' + price.toFixed(2))
                .attr('data-value', price)
                .data('value', price);

            $(window).trigger('recalc');

            var label = $selected.next('.label-contents').find('.shipping-method-description').text();
            $('#show-ship-method').html(label);

            var address = activeShippingAddress();

            $(window).trigger('tax', [address]);

            window.resetPayPal();
        })
        // set shipping address
        .on('shipping.setaddress', function(event, address, onInit, isDirty) {
            onInit = onInit === undefined ? true : !!onInit;
            isDirty = isDirty === undefined ? 0 : isDirty;

            $('#excise-duties').toggle( !!(address.country !== 'US') );
            $('#order-review-card').toggleClass('ca-resident', !!(address.state_province === 'CA'));

            if(onInit) {
              loadShippingMethods(address, isDirty);
              return;
            }

            $('#transit-days').toggle( !!(address.country === 'US' && !shipLtlOnly()) );

            $(window).trigger('tax', [address]);
        })
        // change address
        .on('ship.alteraddress', function(event) {
            window.$shipRates.html('<div class="alert alert-info">Please confirm your shipping address to display&nbsp;rates</div>');

            window.resetPayPal();
        })
        // panels
        .on('stall.panel', function(event, type) {
            var filter = type === 'bill' ? 'billing' : 'shipping';
            var btn = (type === 'bill') ? '#checkout-submit' : null;

            window.$panels.filter('#'+filter+'-panel').stallPanel(btn);
        })
        .on('release.panel', function(event, type) {
            var filter = type === 'bill' ? 'billing' : 'shipping';
            var btn = (type === 'bill') ? '#checkout-submit' : null;

            window.$panels.filter('#'+filter+'-panel').releasePanel(btn);
        })
        // steps
        .on('next.step', function(event, current, next) {
            if(current === '#shipping-panel') {
                $('#sidebar-shipping, #sidebar-method').removeClass('hide');
            }
        })
        .on('prev.step edit.step', function(event, current, prev) {
            if(prev === '#shipping-panel') {
                $('#sidebar-shipping, #sidebar-method').addClass('hide');
            }
        });


    window.$shipRates.shippingMethods({
        triggerOnInit: true
    });

    $('#order-review-card').responsiveCardCollapse({
        triggerOnLoad: true,
        triggerSize: 728,
        activatedCallback: function(action) {
            this.$element.toggleClass('is-dispatcher-notified', action === 'open' ? true  : false);
        }
    });


    // handle addresses
    $('.checkout-address-book')

        .on('change', '.address-radio', function() {
            $(this).closest('.wrapping-label').addClass('selected')
                .siblings('.selected').removeClass('selected');
        })

        .on('click', '.change-address', function(event) {
            var $grp = $(event.delegateTarget);
            $grp.removeClass('confirmed')
                .data('current', $grp.find('.address-radio:checked').data('address').uuid);

            $('html, body').delay(250).animate({
                scrollTop: $grp.offset().top - 20
            }, 350);

            $(window).trigger($grp.data('addressType')+'.alteraddress');

            $(window).trigger('stall.panel', [$grp.data('addressType')]);

            if($grp.data('addressType') === 'bill') {
              $('#confirm-address-msg').show();
            }

            if(window.shipRateXHR) {
                window.shipRateXHR.abort();
                window.shipRateXHR = null;
            }
        })

        .on('click', '.confirm-address', function(event) {
            var $grp     = $(event.delegateTarget);
            var $checked = $grp.find('.address-radio:checked');
            var address  = $checked.data('address');
            var isDirty  = (address.uuid !== $grp.data('current')) ? 1 : 0;

            $(window).trigger('release.panel', [$grp.data('addressType')]);

            if($grp.data('addressType') === 'bill') {
              $('#confirm-address-msg').hide();
            }

            $(window).trigger('persistAddress', [address, ($grp.data('addressType') === 'ship' ? 'ship' : 'bill')]);

            $grp.addClass('confirmed').removeData('current');

            if($grp.is('#ship-addresses')) {
                $(window).trigger('shipping.setaddress', [address, undefined, isDirty]);

                $('html, body').delay(250).animate({
                    scrollTop: $('#checkout-shipping-information').offset().top - 50
                }, 350);

                rememberAddress('ship', $checked.val());
            }
        })

        // new
        .on('click', '.add-address', function(event) {
            var $grp = $(event.delegateTarget);

            $grp.hide();

            $('#add-'+$grp.data('addressType')+'-address').show()
                .find(':input').enable();
        });

    $('.checkout-address-book').find('.address-radio:checked').trigger('change');


    var checkAddress;
    if($('#ship-addresses').find('.address-radio:checked:first').length > 0) {
        var forceMethods = !(window.$shipRates.find('> label:first').length > 0);
        checkAddress = $('#ship-addresses .address-radio:checked:first').data('address');

        $(window).trigger('persistAddress', [checkAddress, 'ship']);
        $(window).trigger('shipping.setaddress', [checkAddress, forceMethods]);
    }

    // if($('#bill-addresses').find('.selected').length > 0) {
    //     $(window).trigger('persistAddress', [
    //         $('#bill-addresses .address-radio:checked').data('address'),
    //         'bill'
    //     ]);
    // }

    var $addShip = $('#add-ship-address:first');
    if($addShip.length > 0) {
        $addShip
            .addressBook({
                buttonSelector: '.address-confirm:first',
                formSelector: '.address-form-wrap:first',
                savedCallback: function(response) {
                    var that = this;

                    insertAddress(response.address, 'ship');

                    if(that.$modal !== undefined) {
                        that.$modal.modal('hide');
                    }

                    that._cleanup();

                    $addShip.find('.address-cancel:first').trigger('click');
                }
            })
            .on('click', '.address-cancel', function(event) {
                var $add = $(event.delegateTarget);

                $('#'+$add.data('addressType')+'-addresses').show();

                $add.hide()
                    .find('.address-form-wrap:first')
                        .find('input:text, input[type="tel"]').disable().val('');
            })
            .find(':input').disable();
    }

    var $addBill = $('#add-bill-address:first');
    if($addBill.length > 0) {
        $addBill
            .addressBook({
                buttonSelector: '.address-confirm:first',
                formSelector: '.address-form-wrap:first',
                savedCallback: function(response) {
                    var that = this;

                    insertAddress(response.address, 'bill');

                    if(that.$modal !== undefined) {
                        that.$modal.modal('hide');
                    }

                    that._cleanup();

                    $addBill.find('.address-cancel:first').trigger('click');
                }
            })
            .on('click', '.address-cancel', function(event) {
                var $add = $(event.delegateTarget);

                $('#'+$add.data('addressType')+'-addresses').show();

                $add.hide()
                    .find('.address-form-wrap:first')
                        .find('input:text, input[type="tel"]').disable().val('');
            })
            .find(':input').disable();
    }

    // payment method selector
    $('[name="payment_card"]').on('change', function() {
        var $me = $(this);
        var toggle = $me.val() === 'new';

        $('.payment-method-selection-form .cvv-block')
            .hide()
            .find(':input')
            .disable();

        $me.closest('label').next('.cvv-block')
            .show()
            .find(':input:first')
            .enable();

        $('#cc-form').toggleClass('hide', !toggle)
            .find(':input')
            .prop('disabled', !toggle);
    }).filter(':checked').trigger('change');

    $('[name="payment_method"]').on('change', function() {
        var $me = $(this);
        var toggle = $me.val() !== 'paypal';

        $('#paypal-form').toggleClass('hide', toggle);

        $('#creditcard-form').toggleClass('hide', !toggle)
            .find(':input')
            .prop('disabled', !toggle);

        if(toggle) {
            $('[name="payment_card"]')
                .filter(':checked')
                .trigger('change');
        }

        if(window.paypal_enabled) {
          window.getParsleyPaypalInstance().removeError('paypal-auth-custom');
        }
    }).filter(':checked').trigger('change');

});





window.loadShippingMethods = function(destination, isDirty) {
    if(!destination) {
        return;
    }

    var $loader = $('#ship-rate-loader');
    isDirty = isDirty === undefined ? 0 : isDirty;

    $loader.show();
    window.$shipRates.hide();
    $('#transit-days').toggle(false);

    window.$panels.filter('#shipping-panel').stallPanel();

    window.shipRateXHR = $.get('/ship_methods', {
        'destination': destination,
        'force': isDirty
    }, null, 'json')
        .fail(function(xhr) {
            if(xhr.status === 0 && xhr.statusMessage === 'abort') {
                return;
            }
        })
        .done(function(response) {
            var markup = '';
            var first = false;
            var previous = window.$shipRates.data('prev-selected') || false;

            if(Object.keys(response).length > 0) {

                for (var key in response) {
                    let item = response[key];

                    if(previous) {
                        if(previous === item.shipCodeXRef) {
                            item.checked = true;
                        }
                    } else if(!first) {
                        item.checked = true;
                        first = true;
                    }

                    markup += Handlebars.templates['ship_method'](item);
                }

                window.$shipRates.html(markup);

                var $checked = window.$shipRates.find(':checked:first');
                if($checked.length === 0) {
                    $checked = window.$shipRates.find('.radio:first');
                    $checked.prop('checked', true);
                }

                $checked.trigger('change');

                $('#transit-days').toggle( !!(destination.country === 'US' && !shipLtlOnly()) );
            }
        })
        .always(function() {
            $loader.hide();
            window.$shipRates.show();

            window.$panels.filter('#shipping-panel').releasePanel();
        });
}

window.updateTax = function(address) {
    if(!address) return;

    window.taxRateXHR = $.get('/update_tax', {
        'address': address,
        'freight': Number($('#order-freight').data('value') || 0.00)
    }, null, 'json')
        .fail(function(xhr) {
            if(xhr.status === 0 && xhr.statusMessage === 'abort') {
                return;
            }
        })
        .done(function(response) {
            var salesTax = parseFloat(response.tax);

            $('#checkout-order-review-summary').replaceWith(response.html);

            // $('#order-tax').text('$' + salesTax.toFixed(2))
            //     .attr('data-value', salesTax)
            //     .data('value', salesTax);

            $(window).trigger('recalc');
        });
}

window.activeShippingAddress = function() {
    return $('#ship-addresses').length
        ? $('#ship-addresses').find('.address-radio:checked').data('address')
        : stripFromKeys($('#ship-address').find('.modify :input').serializeJSON(), 'ship_');
};

window.rememberAddress = function(type, value) {
    if(!value) return;

    type = (type === 'undefined') ? 'ship' : type;

    $.post('/remember_address', {
        type: type,
        id: value
    });
};

function shipLtlOnly() {
    var $rates = window.$shipRates.find('> label');

    if($rates.length === 1 && $rates.first().attr('for') === 'shipping-method--LTL') {
        return true;
    }

    return false;
}

function updateOrderTotal() {
    var total = 0.00;
    var discount = Number($('#order-discount').data('value') || 0.00);
    var values = [
        Number($('#order-subtotal').data('value') || 0.00),
        Number($('#order-freight').data('value') || 0.00),
        Number($('#checkout-order-review-summary [id^="order-tax-"]').toArray().reduce((carry, row) => carry + Number(row.dataset.value), 0)),
        Number($('#checkout-order-review-summary [id^="order-fee-"]').toArray().reduce((carry, row) => carry + Number(row.dataset.value), 0)),
    ];

    total = values.reduce(function(total, value) {
        return Number(total) + Number(value);
    }, total).toFixed(2);

    total -= discount.toFixed(2);

    window.orderTotals = {
        discount: discount,
        freight: values[1],
        subtotal: values[0],
        tax: values[2],
        fees: values[3],
        total: total,
    };

    $('#order-total, #order-review-total').text('$' + total.toFixed(2)).data('value', total);
}

function insertAddress(address, addressType) {
  var $books = $('.checkout-address-book[data-address-type="ship"]:first, .checkout-address-book[data-address-type="bill"]:first');

  $books.each(function() {
    var $list = $(this).find('.address-list:first');

    address['type'] = $(this).data('addressType');

    $list.append(Handlebars.templates['address_input'](address));

    if(addressType == $(this).data('addressType')) {
      $('label', $list).find(':input:first').trigger('click');
    }
  });
}
